import { render, staticRenderFns } from "./Word.vue?vue&type=template&id=3850bb8e&scoped=true"
import script from "./Word.vue?vue&type=script&lang=js"
export * from "./Word.vue?vue&type=script&lang=js"
import style0 from "./Word.vue?vue&type=style&index=0&id=3850bb8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3850bb8e",
  null
  
)

export default component.exports